var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine1Cup0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41751 7.21553C2.63781 4.79954 2.74796 3.59155 3.30423 2.66876C3.79355 1.85706 4.5164 1.19712 5.36918 0.783537C6.33867 0.313354 7.55167 0.313354 9.97768 0.313354H26.4383C28.8644 0.313354 30.0774 0.313354 30.9611 0.783537C31.7385 1.19712 32.341 1.85706 32.6823 2.66876C33.0702 3.59155 32.9601 4.79954 32.7398 7.21553L31.2451 23.6082C31.0248 26.0242 30.9146 27.2322 30.3583 28.155C29.869 28.9667 29.1462 29.6266 28.2934 30.0402C27.3239 30.5104 26.1109 30.5104 23.6849 30.5104H7.22423C4.79822 30.5104 3.58521 30.5104 2.70147 30.0402C1.92411 29.6266 1.32161 28.9667 0.980324 28.155C0.592333 27.2322 0.702482 26.0242 0.922779 23.6082L2.41751 7.21553Z",
    fill: "#7F15BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5163 7.15104H19.6186L17.9783 22.8147H15.3446L16.5921 10.9168H16.569L14.5129 12.8574H14.4898L14.7901 9.99267L17.5163 7.15104Z",
    fill: "#ECEAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1Cup0);
export default __webpack_public_path__ + "static/media/line-1-cup-0.c019e7f97fa03966ff154f66bcc4293b.svg";
export { ForwardRef as ReactComponent };